export default __webpack_public_path__ + "static/media/afterburner.a9e35c87.png";